import { Injectable } from '@angular/core';
import { BBService } from 'bookingbug-core-js';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { FormGroup } from '@angular/forms';
@Injectable({
	providedIn: 'root',
})
export class DatastoreService {

	constructor(
		private router: Router
	) {
		this.isCitizenship$ = this.citizenship.asObservable();

	}

	// new function called agentRestart
	agentRestart() {
		// clear all localstorage
		localStorage.clear();

		//clear all session storage
		sessionStorage.clear();

		//clear variables
		this.startQuestions = null;
		this.type_of_appointment = null;
		this.appointment_type = null;
		this.totalCost = null;
		this.pageContent = null;
		this.reference = null;
		this.isCitizenshipRoute = null;
		this.dateCapInitDate = null; // used to cap calendar dates one year from entered date

		// client details
		this.booker_first_name = null;
		this.booker_last_name = null;
		this.booker_email = null;
		this.booker_phone = null;
		this.lookupResponses = [];
		this.costBreakDown = null;
		this.selectedAddress = null;
		this.setService = null;
		this.setResource = null;
		this.extraDuration = 0; // obtained from questions
		this.childDob = false;
		this.bookingQuestions = [];
		this.unselectedLocations = [];
		this.bookingForm = null;
		this.companyAnswers = null;
		this.selectedDate = null;
		this.selectedSlot = null;
		this.selectedResource = null;
		this.selectedService = null; //used only to store the service incase we switch to the alt one
		this.selectedDepartment = null; //used only to store the service incase we switch to the alt one
		this.locations = [];
		this.bookingAnswers = null;

		if (this.isCitizenshipRoute) {
			this.router.navigate(['/start/citizenship']);
			return;
		} else {
			this.router.navigate(['/agent']);
			return;
		}
	}

	startQuestions: any;
	type_of_appointment: any;
	appointment_type: any;
	public totalCost: any;
	public pageContent: any;

	public firstSlotAnalytic: any;
	public firstSlotAnalyticKey: string;

	public reference: any;
	public isCitizenshipRoute: any;
	public dateCapInitDate: any; // used to cap calendar dates one year from entered date

	public serviceQuestionSchema: Record<string, any>;
	public selectedSchema: string;
	companyQuestionsForm: FormGroup = new FormGroup({});

	// client details
	public booker_first_name: any;
	public booker_last_name: any;
	public booker_email: any;
	public booker_phone: any;
	public lookupResponses: any[] = [];
	public costBreakDown: any;
	public selectedAddress: any;

	public setService: any;
	public setResource: any;
	public staff_set: any;
	public autoSelectedStaff: any;

	public extraDuration = 0; // obtained from questions

	public childDob: any = false;

	public bookingQuestions = [];

	public unselectedLocations = [];

	public bookingForm;
	public companyAnswers;

	public selectedDate;

	public selectedSlot;

	public selectedResource;

	public selectedService; //used only to store the service incase we switch to the alt one
	public selectedDepartment; //used only to store the service incase we switch to the alt one

	public locations = [];

	public bookingAnswers;

	public customerDetailsForm;

	public client;

	public clientCreated = false;

	public address;

	public latitude;

	public longitude;

	public endSlot;

	public customerQuestions;

	public companyQuestions;

	public address1;

	public selectedLocation;

	public booking;

	public totalPrice;

	public adminJourney = false;

	public adminAuthToken = '';

	public purchase: any;

	public serviceBookingType: any;

	public selectedSuggestion: any;

	public config: any;

	public serviceFees: any;

	public _extraItems = [];

	public ceremonyDate: any;

	public deathDate: any;

	public mccdRegDate: any;

	public journeyRoute: string;

	public skipLocationsPage = false;

	public postageCounts: any;

	public citizenshipFees = {
		'mon_fri_9_5': {
			'individual': "928030d9-1e52-40ff-bf89-8f1b93ad31ad",
			'family': "61a90ab1-5935-4db7-a63f-3940d7309994",
		},
		'mon_fri_after_5': {
			'individual': "e1cd9f1b-c8f5-4b6d-a8a5-71d4145c3f0e",
			'family': "a200c0f7-2bb9-4878-91f6-3423d6f8fb50"
		},
		'sat': {
			'individual': "b4c4c1e4-40bb-4290-a4a2-bcc0e9cc410b",
			'family': "e1752c06-3f94-409e-9dd5-286bdb1d88d9"
		},
		'sun': {
			'individual': "00067b6c-157b-410f-946c-9d0a7941ed3d",
			'family': "af1cd948-939e-4ca5-b9cc-f360fcf2501b"
		}
	};
	public citizenshipGroupFees = {
		'mon_fri_9_5': {
			'individual': "4c05c209-c22c-4be8-899d-da9d260aa0ce",
			'family': "425a6520-60b0-4bdd-bd9d-d5cefe4c63c9",
		},
		'mon_fri_after_5': {
			'individual': "dc4d8403-19c8-4ed3-960f-e7c16f4ce4ff",
			'family': "969cc33d-7e66-4e54-b1ee-39b009aeb855"
		},
		'sat': {
			'individual': "7a19c1d7-05b8-44da-8ab6-75570ec5364b",
			'family': "88da707f-80f6-4325-98fa-740c0c6fbfee"
		},
		'sun': {
			'individual': "a2ae60ab-2dd8-4cf6-845e-2e0b04750826",
			'family': "795b0c1a-295f-419e-a2c1-f87e05c34dcb"
		}
	};
	public citizenshipKey = '';

	public familyCitizenshipBooking = false;

	public groupCitizenshipBooking = false;

	public citizenshipExtraItem;

	notify: Subject<boolean> = new Subject<boolean>();
	onNotify(event) {
		this.notify.next(true);
	}

	private addFeesSubject = new BehaviorSubject<any>(null);
	addFees$ = this.addFeesSubject.asObservable();
	triggerAddFees(fees: any) {
		this.addFeesSubject.next(fees);
	}

	public citizenship: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public isCitizenship$: Observable<boolean>;
	updateCitizenship(val: boolean) {
		this.citizenship.next(val);
	}

	public certificateStore: any;

	public applicationStore:
		| {
			formData: Record<string, string> | undefined;
			applicationType: string;
			formId: string;
			applicationNumber: string | undefined;
		}
		| undefined;
}
